import { useState } from 'react';

import classNames from 'classnames';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import ImageProxy from '@next-image-proxy';

import { Modal, ModalClose, ModalContent } from '@uikit';

import { DeserializedAppMediaData } from '@api';

import Close from '@uikit/icons/Close';

interface AppDetailsGalleryProps {
  media: DeserializedAppMediaData[];
  className?: string;
  appName: string;
}

const altsForSlider = [
  ':appName',
  ':appName Review',
  ':appName Login',
  ':appName Dashboard',
  ':appName Magic Store',
];

const AppDetailsGallery = ({ media, className, appName }: AppDetailsGalleryProps) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="overflow-hidden -mb-7">
        <Swiper
          className={classNames('-mx-3 pb-7', className)}
          centeredSlides
          breakpoints={{
            568: {
              centeredSlides: false,
            },
          }}
          slidesPerView="auto"
        >
          {media.map((mediaItem, index) => (
            <SwiperSlide
              key={mediaItem.id}
              className="select-none px-2 w-[calc(100%-30px)] sm:w-1/2 lg:w-1/3"
              onClick={() => {
                setIsOpen(true);
                setActiveSlide(index);
              }}
            >
              <ImageProxy
                alt={
                  altsForSlider?.[index]
                    ? altsForSlider[index].replace(':appName', appName)
                    : `${appName} #${index}`
                }
                width={1400}
                height={642}
                priority={index < 3}
                sizes="(min-width: 568px) 50vw, (min-width: 992px) 33vw, 100vw"
                src={mediaItem.attributes.file}
                className="w-full object-cover bg-primary-100 aspect-[1400/642] rounded-2xl"
                data-qa="info-image"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <ModalContent
          className="relative p-0 border-0 lg:w-[70%] lg:max-w-[150vmin] py-12 lg:p-12 bg-transparent shadow-none rounded-none w-full overflow-hidden"
          overlayClassName="p-0"
        >
          <div className="absolute w-full mx-auto top-0 left-0 right-0 max-lg:max-w-xl max-lg:px-5 flex justify-end">
            <ModalClose className="icon-button text-neutral-50 hover:bg-secondary">
              <Close className="icon" />
            </ModalClose>
          </div>

          <Swiper
            className="w-full max-lg:px-10 app-page-swiper-navigation static"
            initialSlide={activeSlide}
            slidesPerView="auto"
            centeredSlides
            modules={[Navigation, Pagination]}
            centeredSlidesBounds
            grabCursor
            navigation={true}
            breakpoints={{
              992: {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 20,
              },
            }}
          >
            {media.map((mediaItem, index) => (
              <SwiperSlide
                key={mediaItem.id}
                className={classNames(
                  'select-none max-w-full max-lg:px-2.5 aspect-[1400/642] max-lg:w-[100vmin]',
                )}
              >
                <ImageProxy
                  src={mediaItem.attributes.file}
                  alt={
                    altsForSlider?.[index]
                      ? altsForSlider[index].replace(':appName', appName)
                      : `${appName} #${index}`
                  }
                  width={1400}
                  height={642}
                  sizes="(min-width: 992px) 60vw, 100vw"
                  className="w-full h-full object-cover rounded-2xl bg-primary-100 "
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AppDetailsGallery;
